[
  {
    "key": "ocean",
    "name": "Ocean",
    "water": true,
    "passable": true,
    "deep": true,
    "yields": {
      "food": 1,
      "production": 0,
      "gold": 2
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#15395C",
    "description": "Deep water. Crossable only by ships built for the open sea.",
    "_deep": "Deep water: coastal ships (galleys, ironclads) cannot enter it."
  },
  {
    "key": "coast",
    "name": "Coast",
    "water": true,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 2,
      "production": 0,
      "gold": 2
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#2F7FA6",
    "description": "Shallow water within sight of land. The cradle of early seafaring."
  },
  {
    "key": "lake",
    "name": "Lake",
    "water": true,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 3,
      "production": 0,
      "gold": 1
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#3E98BE",
    "description": "Fresh water. Feeds the land around it and never needs irrigating."
  },
  {
    "key": "grassland",
    "name": "Grassland",
    "water": false,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 3,
      "production": 0,
      "gold": 0
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#7BA24E",
    "description": "Deep soil and reliable rain. Where populations grow fastest."
  },
  {
    "key": "plains",
    "name": "Plains",
    "water": false,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 2,
      "production": 1,
      "gold": 0
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#C4B06A",
    "description": "Open, workable country. Feeds a city and equips it too."
  },
  {
    "key": "desert",
    "name": "Desert",
    "water": false,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 0,
      "production": 1,
      "gold": 0
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#E3CC91",
    "description": "Barren without a river or an oasis, but it hides what the rock holds."
  },
  {
    "key": "tundra",
    "name": "Tundra",
    "water": false,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 1,
      "production": 0,
      "gold": 0
    },
    "movementCost": 1,
    "defenceBonus": 0,
    "colour": "#AEB7AC",
    "description": "Frozen ground that thaws briefly and grudgingly."
  },
  {
    "key": "hills",
    "name": "Hills",
    "water": false,
    "passable": true,
    "deep": false,
    "yields": {
      "food": 1,
      "production": 2,
      "gold": 0
    },
    "movementCost": 2,
    "defenceBonus": 50,
    "colour": "#A08A57",
    "description": "Hard to farm, rich in stone and ore, and unpleasant to attack uphill."
  },
  {
    "key": "mountains",
    "name": "Mountains",
    "water": false,
    "passable": false,
    "deep": false,
    "yields": {
      "food": 0,
      "production": 1,
      "gold": 0
    },
    "movementCost": 99,
    "defenceBonus": 100,
    "colour": "#6F675E",
    "description": "Impassable to armies. A border no treaty is needed to enforce."
  }
]
